<template>
    <div class="personal" v-show="token">
        <div class="title-bar">
            <!--
            <img src="//images.jinku.com/newjk/org/images/personal/personal_01.jpg" alt="" style="width: .19rem;
            height: .34rem;"> -->
            <strong style="font-size: .36rem;">个人中心</strong>
        </div>
        <div class="personal-center">
            <div class="peo">
                <img :src="this.userAvatar" alt="" style="width: 1.17rem;height: 1.17rem;border-radius: 50%;">
            </div>
            <div class="pei">
                <p>{{this.userName}}</p>
                <p>{{this.orgEndDate}}&nbsp;到期</p>
            </div>
        </div>
        <ul class="personal-list clearfix">
            <li v-on:click="myCourse">
                <img src="//images.jinku.com/newjk/org/images/personal/personal_04.jpg" alt="" style="width: .26rem;height: .26rem;margin-left: .31rem;margin-right: .28rem;">
                <span>我的课程</span>
                <span style="float: right;margin-right: .3rem;">></span>
            </li>
            <li v-on:click="myPaper">
                <img src="//images.jinku.com/newjk/org/images/personal/personal_05.jpg" alt="" style="width: .26rem;height: .26rem;margin-left: .31rem;margin-right: .28rem;">
                <span>我的作业</span>
                <span style="float: right;margin-right: .3rem;">></span>
            </li>
            <!--
            <li>
                <img src="//images.jinku.com/newjk/org/images/personal/personal_06.jpg" alt="" style="width: .26rem;height: .26rem;margin-left: .31rem;margin-right: .28rem;">
                <span>观看历史</span>
                <span style="float: right;margin-right: .3rem;">></span>
            </li>
            -->
            <li @click="changePwd">
                <img src="//images.jinku.com/newjk/org/images/personal/personal_07.jpg" alt="" style="width: .26rem;height: .26rem;margin-left: .31rem;margin-right: .28rem;">
                <span>修改密码</span>
                <span style="float: right;margin-right: .3rem;">></span>
            </li>
            <li @click="certification">
                <img src="//images.jinku.com/newjk/org/images/personal/personal_08.jpg" alt="" style="width: .26rem;height: .26rem;margin-left: .31rem;margin-right: .28rem;">
                <span>实名认证</span>
                <span style="float: right;margin-right: .3rem;">></span>
            </li>
            <li class="last" @click="aboutUs">
                <img src="//images.jinku.com/newjk/org/images/personal/personal_09.jpg" alt="" style="width: .26rem;height: .26rem;margin-left: .31rem;margin-right: .28rem;">
                <span>关于我们</span>
                <span style="float: right;margin-right: .3rem;">></span>
            </li>
        </ul>
        <div style="width: 100%;text-align: center;margin-top: .7rem;">
            <button class="lon" @click="logout">退出登录</button>
        </div>

        <bar></bar>
    </div>
</template>

<script>

    import http from "../../lib/http";
    import common from "../../lib/common";
    import bar from "../tab-bar/bar.vue";

    export default {
        name: 'personal',
        data() {
            return {
                userName:'', //用户名
                userAvatar:'', //头像
                orgEndDate:'', //过期时间
                token:false
            }
        },
        components:{
            bar
        },
        methods:{
            getUserInfo:function(){
                const self = this;
                http({
                    method: "post",
                    url: "/org/user/get",
                    data: ""
                }).then(function(res){
                    if(res.code ==0){
                        self.userName = res.data.user_name;
                        self.userAvatar = res.data.user_headimg;
                        self.orgEndDate = res.data.org_end_date;
                    }
                }).catch(function(err){

                });
            },
            myCourse:function(){
                this.$router.push('/Course');
            },
            myPaper:function(){
                this.$router.push('/my-paper');
            },
            certification:function(){
                this.$router.push('/certification');
            },
            changePwd:function () {
                this.$router.push('/amend');
            },
            aboutUs:function () {
                window.location.href = 'https://m.jinku.com/about/';
            },
            logout:function () {
                const self = this;
                http({
                    method: "post",
                    url: "/user/logout",
                    data: ""
                }).then(function(res){
                    self.$router.push('/login');
                }).catch(function(err){

                });
            },
        },
        created(){
            this.getUserInfo();
            var isToken = document.cookie.split(';');
            if(isToken!=""){
                this.token = true;
            }
        },
    }
</script>

<style scoped>
    .title-bar {
        position: relative;
        text-align: center;
        margin-top: .36rem;
        margin-bottom: .27rem;
    }

    .title-bar img,
    .title-bar strong {
        vertical-align: middle;
    }

    .title-bar img {
        position: absolute;
        left: .3rem;
        top: 20%;
    }

    .personal-center {
        width: 100%;
        height: 4.41rem;
        background-image: url(http://images.jinku.com/newjk/org/images/personal/personal_bg_02.png);
        background-repeat: no-repeat;
        background-size: 100%;
        position: relative;
    }

    .portrait {
        position: relative;
    }

    .peo {
        width: 1.17rem;
        height: 1.17rem;
        border-radius: 50%;
        background-color: white;
        position: absolute;
        top: .67rem;
        left: .79rem;
        box-shadow: 0px 0px 10px aliceblue;
    }

    .pei {
        position: absolute;
        top: .8rem;
        left: 2.22rem;
    }

    .pei p {
        color: white;
    }

    .pei p:nth-child(1) {
        font-size: .36rem;
    }

    .pei p:nth-child(1) {
        font-size: .28rem;
    }

    .personal-list li {
        height: .99rem;
        line-height: .99rem;
        color: #717183;
        font-size: .26rem;
        border-bottom: .01rem solid #E6E6E6;
    }

    .personal-list li img {
        vertical-align: middle;
    }

    .personal-list li span {
        vertical-align: middle;
    }

    .clearfix:after {
        /*伪元素是行内元素 正常浏览器清除浮动方法*/
        content: "";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }

    .clearfix {
        *zoom: 1;
        /*ie6清除浮动的方式 *号只有IE6-IE7执行，其他浏览器不执行*/
    }
    .last{
        border-bottom: none !important;
    }
    .lon{
        width: 6.06rem;
        height: .78rem;
        color: white;
        font-size: .28rem;
        line-height: .78rem;
        text-align: center;
        background: #087AFE;
        border-radius: .03rem;
        border: none;
        margin-bottom: 2rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/personal/personal.vue